@import "../shared.css";

* {
	box-sizing: border-box;
}
:host {
	position: relative;
	width: 100%;
	justify-content: center;
	align-items: center;
	display: flex;
	background-color: rgb(var(--smoothly-input-background));
	box-sizing: border-box;
}
:host>div:not([slot]) {
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	padding-right: var(--input-padding-side);
}
:host>div>smoothly-input {
	width: 12em;
	--input-min-height: calc(3rem - 2px);
	--smoothly-input-border-focus: none;
}
:host>div>smoothly-input label {
	white-space: nowrap;
}
:host.output-side-right>div {
	padding: 0;
}
:host.output-side-right>div>smoothly-input {
	text-align: center;
	margin-left: var(--input-padding-side);
	border: none;
	box-sizing: border-box;
	width: 6rem;
	order: 3;
	margin: 0;
}
:host.output-side-right>div>smoothly-display,
:host:not(.output-side-right)>div>label {
	display: none;
}
:host.output-side-right>div>smoothly-input input {
	padding: 0;
	text-align: center;
}
:host.output-side-right>div>smoothly-input label {
	width: 100%;
}
:host.output-side-right>div>label {
	position: static;
	font-size: inherit;
	text-align: center;
	margin: 0 var(--input-padding-side);
}

/*--------------------Reset browserspecific CSS------------------ */
:host>div>input[type=range] {
	-webkit-appearance: none;
	/* Hides the slider so that custom slider can be made */
	width: 100%;
	/* Specific width is required for Firefox. */
	background: transparent;
	/* Otherwise white in Chrome */
	height: 1.5em;
	padding: 0 .4em;
}

/*--------------------THUMB------------------ */
/* WebKit/Blink */
:host>div>input[type=range]::-webkit-slider-thumb {
	-webkit-appearance: none;
	height: 0.8em;
	width: 0.8em;
	border-radius: 100%;
	margin-top: -.25em;
	border: none;
	/* You need to specify a margin in Chrome, but in Firefox and IE it is automatic */
}
:host:not([disabled]):not([readonly])>div>input[type=range]::-webkit-slider-thumb {
	background-color: rgb(var(--smoothly-primary-color));
	cursor: pointer;
}

/* Firefox */
:host>div>input[type=range]::-moz-range-thumb {
	height: 0.8em;
	width: 0.8em;
	border-radius: 100%;
	border: none;
	background-color: rgb(var(--smoothly-input-foreground));
}
:host:not([disabled]):not([readonly])>div>input[type=range]::-moz-range-thumb {
	background-color: rgb(var(--smoothly-primary-color));
	cursor: pointer;
}

/*--------------------SLIDER TRACK------------------ */
:host>div>input[type=range]::-webkit-slider-runnable-track {
	height: .3rem;
	border-radius: 20px;
	background-color: rgb(var(--smoothly-input-foreground));
}
:host:not([disabled]):not([readonly])>div>input[type=range]::-webkit-slider-runnable-track {
	background-color: rgb(var(--smoothly-primary-color));
	cursor: pointer;
}

:host>div>input[type=range]::-moz-range-track {
	width: 100%;
	height: .3rem;
	border-radius: 20px;
	background-color: rgb(var(--smoothly-input-foreground));
}
:host:not([disabled]):not([readonly])>div>input[type=range]::-moz-range-track {
	background-color: rgb(var(--smoothly-primary-color));
	cursor: pointer;
}

:host:not([value]):not([disabled]):not([readonly])>div>input[type=range]::-webkit-slider-runnable-track {
	background-color: rgb(var(--smoothly-primary-tint));
}

:host:not([value]):not([disabled]):not([readonly])>div>input[type=range]::-moz-range-track {
	background-color: rgb(var(--smoothly-primary-tint));
}

:host[disabled]>div>input[type=range]::-webkit-slider-thumb,
:host[disabled]>div>input[type=range]::-moz-range-thumb,
:host[disabled]>div>input[type=range]::-webkit-slider-runnable-track,
:host[disabled]>div>input[type=range]::-moz-range-track,
:host[disabled],
:host[disabled] * {
	cursor: not-allowed
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/*--------------------DUAL MODE------------------ */
:host(.dual)>div>smoothly-input {
	width: 7rem;
	flex: 0 0 auto;
}
:host(.dual) .track {
	position: relative;
	flex: 1;
	height: 1.5em;
	display: flex;
	align-items: center;
}
/* Shared visible track line */
:host(.dual) .track::before {
	content: "";
	position: absolute;
	left: .4em;
	right: .4em;
	height: .3rem;
	border-radius: 20px;
	background-color: rgb(var(--smoothly-input-foreground));
}
:host(.dual) .fill {
	position: absolute;
	height: .3rem;
	border-radius: 20px;
	background-color: rgb(var(--smoothly-primary-color));
	pointer-events: none;
}
/* Match the single range: the active fill drops to the foreground color when readonly/disabled. */
:host(.dual[readonly]) .fill,
:host(.dual[disabled]) .fill {
	background-color: rgb(var(--smoothly-input-foreground));
}
/* Both range inputs occupy the same box; only their thumbs receive pointer events */
:host(.dual) .track > input[type=range] {
	position: absolute;
	left: 0;
	right: 0;
	width: 100%;
	margin: 0;
	background: transparent;
	pointer-events: none;
}
:host(.dual) .track > input[type=range]::-webkit-slider-runnable-track {
	background: transparent;
}
:host(.dual) .track > input[type=range]::-moz-range-track {
	background: transparent;
}
:host(.dual) .track > input[type=range]::-webkit-slider-thumb {
	pointer-events: auto;
}
:host(.dual) .track > input[type=range]::-moz-range-thumb {
	pointer-events: auto;
}

/*--------------------DUAL MODE THUMBS------------------ */
/* Single-mode thumb rules only match the direct-child :host>div>input, not the nested dual inputs, so replicate them here. */
:host(.dual) .track > input[type=range] {
	-webkit-appearance: none;
}
:host(.dual) .track > input[type=range]::-webkit-slider-runnable-track {
	height: .3rem;
}
:host(.dual) .track > input[type=range]::-moz-range-track {
	height: .3rem;
}
:host(.dual) .track > input[type=range]::-webkit-slider-thumb {
	-webkit-appearance: none;
	height: 0.8em;
	width: 0.8em;
	margin-top: -.25em;
	border-radius: 100%;
	border: none;
	background-color: rgb(var(--smoothly-input-foreground));
}
:host(.dual):not([disabled]):not([readonly]) .track > input[type=range]::-webkit-slider-thumb {
	background-color: rgb(var(--smoothly-primary-color));
	cursor: pointer;
}
:host(.dual) .track > input[type=range]::-moz-range-thumb {
	height: 0.8em;
	width: 0.8em;
	border-radius: 100%;
	border: none;
	background-color: rgb(var(--smoothly-input-foreground));
}
:host(.dual):not([disabled]):not([readonly]) .track > input[type=range]::-moz-range-thumb {
	background-color: rgb(var(--smoothly-primary-color));
	cursor: pointer;
}
:host(.dual)[disabled] .track > input[type=range]::-webkit-slider-thumb,
:host(.dual)[disabled] .track > input[type=range]::-moz-range-thumb {
	cursor: not-allowed;
}
